<template>
  <div class="default-layout">
    <page-navbar
      :menu="$store.state.common.menu"
      :updated="$store.state.common.updated.menu"
    ></page-navbar>
    <article
      class="default-layout-content"
      :class="{
        'lr-page-container': !style.noWrap,
        'no-padding-top': style.noPaddingTop,
        'no-padding-bottom': style.noPaddingBottom,
      }"
      :style="{ minHeight: style.minHeight }"
    >
      <Nuxt />
    </article>
    <about-us v-if="isShowAboutUs"></about-us>
    <page-footer
      ref="footer"
      :siteInfo="$store.state.common.siteInfo"
      :links="$store.state.common.links"
      :updated="`${$store.state.common.updated.links}${$store.state.common.updated.siteInfo}`"
    ></page-footer>

    <page-sidebar></page-sidebar>
    <div
      class="default-layout-loading"
      v-if="$store.state.common.renderData.loading"
    >
      <img :src="loadingGif" />
      <p>载入页面中，请稍候</p>
    </div>
  </div>
</template>

<script>
import PageNavbar from '@/components/page-navbar';
import PageFooter from '@/components/page-footer';
import PageSidebar from '@/components/page-sidebar';
import { isInWps } from '@/common/utils';
import accountEvent from '@wps/wps_client_api/event/account';
import wpsoffice from '@wps/wps_client_api/wpsoffice';
import loadingGif from '@/assets/image/loading.gif';
import AboutUs from '@/components/about-us';

export default {
  data() {
    return {
      style: {
        noWrap: false,
        noPaddingTop: false,
        noPaddingBottom: false,
        minHeight: 'calc(100vh - 72px - 246px)',
      },
      isInit: false,
      loadingGif,
    };
  },

  components: {
    PageNavbar,
    PageFooter,
    PageSidebar,
    AboutUs,
  },

  computed: {
    isShowAboutUs() {
      return this.$route.name === 'knowledge';
    },
  },

  watch: {
    '$store.state.user.userInfo': {
      handler(userInfo) {
        this.checkIsRouteAuth(userInfo);
        // 切换账户 / 退出登录的时候会将 userInfo 设置为 null
        if (!userInfo) {
          location.reload();
        }
      },
    },
  },

  methods: {
    /**
     * 初始化打点工具
     */
    async initCollect() {
      // 端内需上报客户端版本
      let version = '0';
      if (isInWps()) {
        try {
          const res = await wpsoffice.getAppInfo();
          version = (res && res.version) || version;
        } catch (error) {
          console.error(error);
        }
      }

      // 登录状态下上报userid
      const userInfo = this.$store.state.user.userInfo;
      const accountId = (userInfo && userInfo.userid) || '';

      this.$collect.init({ version, accountId });
    },

    /**
     * 检查路由权限，需要登陆但无登录状态返回首页
     */
    checkIsRouteAuth(userInfo) {
      if (!userInfo && this.$route.meta.needAuth) {
        location.href = '/learning';
      }
    },
  },

  async mounted() {
    if (this.$store.state.common.renderData.mode === 'csr') {
      await this.$store.dispatch('common/getCommonData', { app: this });
    }

    const { noWrap, noPaddingTop, noPaddingBottom, csrOnly } = this.$route.meta;
    const footerHeight = this.$refs.footer.$el.clientHeight;
    // 设置页面样式属性
    this.style.noWrap = !!noWrap;
    this.style.noPaddingTop = !!noPaddingTop;
    this.style.minHeight = `calc(100vh - 72px - ${footerHeight}px)`;
    this.style.noPaddingBottom = !!noPaddingBottom;

    // 纯CSR页面，直接剔除loading
    if (csrOnly) {
      this.$store.commit('common/setRenderData', { loading: false });
    }

    // 获取用户信息
    await this.$store.dispatch('user/getUserInfo');

    this.checkIsRouteAuth(this.$store.state.user.userInfo);

    // 上报登录信息的展示
    this.$collect.loginShow({
      show: this.$store.state.user.userInfo ? 'success' : 'login',
    });

    // 页面展示了navbar时，上报登录信息
    this.$collect.navbarShow({ show: 'navigation', login: this.$store.state.user.userInfo ? 'yes' : 'no' });

    // 初始化打点工具
    this.initCollect();

    // 端内环境需要监听登入/登出事件
    if (isInWps()) {
      accountEvent.addLoginListener(() => this.$store.dispatch('user/login'));
      accountEvent.addLogoutListener((res) => {
        if (res && res.callstatus === 'ok') {
          this.$store.dispatch('user/logout');
        }
      });

      // 页面退出时要清除
      window.addEventListener('beforeunload', () => {
        accountEvent.removeLoginListener();
        accountEvent.removeLogoutListener();
      });
    }

    // 注册页面的滚动条事件
    window.onscroll = e => {
      this.$eventBus.$emit('@change_scroll', document.documentElement.scrollTop || document.body.scrollTop);
    };
  },

  destroyed() {
    window.onscroll = null;
  },
};
</script>

<style lang="scss" scoped>
.default-layout {
  padding-top: 56px;
  box-sizing: border-box;
  position: relative;

  &-content {
    // 包裹层使用flex布局，里层可通过flex 1，实现全覆盖
    display: flex;
    flex-direction: column;
    padding-top: 30px;
    padding-bottom: 56px;

    &.no-padding-top {
      padding-top: 0;
    }

    &.no-padding-bottom {
      padding-bottom: 0;
    }
  }

  &-loading {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    @include flex-center();
    flex-direction: column;
    background: #fff;
    z-index: 999;

    > img {
      width: 60px;
      margin-bottom: 10px;
    }
  }
}
</style>
